import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ConsentFormService {

    private _f: FormGroup;

    bind(f: FormGroup) {
        this._f = f;
    }

    get f(): FormGroup {
        return this._f as FormGroup;
    }
}
